import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import { Route } from 'react-router-dom'

import Content from 'components/Content'
import FolderMenu from 'components/FolderMenu'
import EmptyAgendas from 'components/EmptyAgendas'
import Text from 'components/Text'
import AgendaTitle from 'components/AgendaTitle'
import TopBar from 'components/TopBar'
import StatusDisplay from 'components/StatusDisplay'
import ShowHide from 'components/ShowHide'
import ConfirmOrCancelDialog from 'components/ConfirmOrCancelDialog'
import { FileFolderShared } from 'material-ui/svg-icons'
import Home from '../../../containers/Home'

class HomeScreen extends React.Component {

   constructor(props) {
      super(props)
   }

   render() {
      const { loggedUser, agendaList, selectedAgenda,
         onOptionSelect, onLogOut, onRefreshAgendas,
         showControlTab, ui, onCloseConfirmOrCancelDialog,
         onConfirmAppointmentCompletion, onConfirmAppointmentCancelation, folders, selectedFolder, selectedAppointment } = this.props

      const hasNoAgendas = !ui.agendas.isLoading && agendaList.length === 0
      const hasAgendas = !ui.agendas.isLoading && agendaList.length > 0

      let ActualComponent = null
      {folders ?
         ActualComponent = folders[selectedFolder].component :
         ActualComponent = null
      }

      return (
         <div className="HomeScreen" >

            <TopBar
               loggedUser={loggedUser}
               agendas={agendaList}
               onAgendaSelect={this.props.onAgendaSelect}
               onRefreshAgendas={onRefreshAgendas}
               onLogOut={onLogOut}
               ui={ui}
            />

            <Content>

               <StatusDisplay status={ui.agendas}>
                  Houve um problema ao carregar as agendas. Por favor recarregue a página.
               </StatusDisplay>

               <ShowHide show={hasNoAgendas}>
                  <EmptyAgendas />
               </ShowHide>

               <ShowHide show={hasAgendas && !selectedAgenda}>
                  <Text>Selecione uma agenda da lista de agendas.</Text>
               </ShowHide>

               <ShowHide show={hasAgendas && !!selectedAgenda}>

                  {/* Doctor name and workplace */}
                  <AgendaTitle agenda={selectedAgenda} />

                  <FolderMenu
                     folders={folders}
                     onOptionSelect={onOptionSelect}
                     selectedFolder={selectedFolder}>
                        
                     {folders ?
                        <Route
                           path={folders[selectedFolder].route}
                           render={(props) =>{
                              return(
                                 <ActualComponent 
                                    {...props} 
                                    onAppointmentStart = {folders.onStartAppointment}
                                    selectedAppointment = {selectedAppointment}
                                 />
                              )
                           } } 
                        /> 
                     : null}

                  </FolderMenu>

               </ShowHide>

            </Content>

            {/* App wide dialogs */}
            <ConfirmOrCancelDialog
               appointment={ui.promptAppointment}
               isOpen={ui.showConfirmDialog || ui.showCancelDialog}
               isCompletionOperation={ui.showConfirmDialog}
               onCancel={onCloseConfirmOrCancelDialog}
               onSubmit={ui.showConfirmDialog ? onConfirmAppointmentCompletion : onConfirmAppointmentCancelation}
            />

         </div>
      )
   }
}
HomeScreen.propTypes = {
   loggedUser: PropTypes.object.isRequired,
   agendaList: PropTypes.array.isRequired,
   onAgendaSelect: PropTypes.func.isRequired,
   onRefreshAgendas: PropTypes.func.isRequired,
   onOptionSelect: PropTypes.func.isRequired,
   onLogOut: PropTypes.func.isRequired,
   showControlTab: PropTypes.bool.isRequired,
   ui: PropTypes.object.isRequired,
   onCloseConfirmOrCancelDialog: PropTypes.func.isRequired,
   onConfirmAppointmentCompletion: PropTypes.func.isRequired,
   onConfirmAppointmentCancelation: PropTypes.func.isRequired,
   folders: PropTypes.object,
   // selectedFolder: PropTypes.number
}

export default HomeScreen



// WEBPACK FOOTER //
// ./src/components/_Screens/Home/index.js